import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogOut = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.99999 4L13.6464 7.64645C13.8417 7.84171 13.8417 8.15829 13.6464 8.35355L9.99999 12M13.6 8H6M7 1.5H3.33333C2.97971 1.5 2.64057 1.63524 2.39052 1.87597C2.14048 2.1167 2 2.44319 2 2.78363V13.2164C2 13.5568 2.14048 13.8833 2.39052 14.124C2.64057 14.3648 2.97971 14.5 3.33333 14.5H7",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})
});
export default SvgLogOut;
